import React from "react";

import {
  DefaultButton,
  TextBadge,
  TopBarDefaultHeader,
  useTheme
} from "@bps/fluent-ui";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { useStores } from "@stores/hooks/useStores.ts";

interface ConditionHeaderProps {
  episodeOfCare: EpisodeOfCare;
}

export const ConditionHeader: React.FC<ConditionHeaderProps> = ({
  episodeOfCare
}) => {
  const theme = useTheme();
  const { routing } = useStores();

  const rightContainer = <DefaultButton text="Close" onClick={routing.back} />;

  return (
    <TopBarDefaultHeader
      backButtonOnClick={routing.back}
      heading={`${episodeOfCare.patient?.name} - ${episodeOfCare.primaryDiagnosis}`}
      leftContainer={
        <TextBadge
          customColors={{ backgroundColor: theme.palette.neutralLighter }}
          styles={{
            root: { padding: "12px 16px", borderRadius: 2 }
          }}
          children="Summary"
        />
      }
      rightContainer={rightContainer}
    />
  );
};
